import styled from "styled-components";

export const BarReportSectionContainer = styled.div`
  margin-bottom: 20px;
`;

export const BarReportSectionHeader = styled.div`
  display: flex;
  flex-flow: row no-wrap;
  justify-content: space-between;
`;

export const ReportSectionContainer = styled.div`
  background-color: var(--aa-surface-bg);
  padding: 20px;
  border-radius: 6px;
`;

export const ReportLabel = styled.span`
  color: var(--aa-text-primary) !important;
`;
